module.exports = __webpack_public_path__ + "static/media/bgHilosHomePC.0a3e490e.jpg";